import React from 'react'
import clsx from "clsx";

import {PageProperties} from './PageProperties'
import {AppIconProps} from "../../atoms/AppIcon/AppIconProps";
import BackButton from "../../atoms/BackButton/BackButton";
import AppIcon from "../../atoms/AppIcon/AppIcon";
import useIsTabletOrDesktop from "../../../hooks/useIsTabletOrDesktop";
import PageHeader from "../../atoms/PageHeader/PageHeader";
import LoanOfferSummaryPanelReadOnly from '../../molecules/LoanOfferSummaryPanelShort/LoanOfferSummaryPanelShort'
import PageLoader from '../../molecules/PageLoader/PageLoader'


import './PageScreen.scss'

/**
 * Komponent – Komponent ekranu
 *
 * @param {PageHeaderProps} title - Tytył wraz z informacją czy wyrenderować ozdobne linie
 * @param {React.ReactNode} page  - zawartość strony
 * @param {AppIconProps} icon - Duża ikona na początku strony
 * @param {Function} onClickBack - Funkcja wywoływana przy kliknięciu przycisku powrót
 * @param {React.ReactNode} panel - Zawartość panelu umieszczonego u góry strony
 */
const PageScreen = (props: PageProperties) => {

    const isMobileDevice = !useIsTabletOrDesktop()
    const {icon, panel, title, showBackButton, children, isContentLoading, onClickBack} = props
    const showBackButtonInMobileVersion = showBackButton && isMobileDevice
    const showBackButtonInDesktopVersion = showBackButton && !isMobileDevice

    const iconProps = React.useMemo<AppIconProps | undefined>(() => {
        const i = icon ?? undefined;
        if (!i) {
            return undefined;
        }
        const extra = panel ? 'page-icon-with-panel' : 'page-icon';
        return {...i, className: clsx(extra, i.className)}
    }, [icon, panel])



    if(props.isLoaderPage) {
        return (
            <main className={clsx('page-screen-wrapper', props.className)}>
                {props.children}
            </main>
        )
    }

    return (
        <main className={clsx('page-screen-wrapper', props.className)}>
            {isContentLoading && (
               <div className={clsx("page-screen-loader-overlay")} >
                  <PageLoader />
               </div>
            )}
            <div className={clsx('page-screen-content', isContentLoading && 'page-screen-content--hidden')}>
                {panel && <div className={showBackButtonInMobileVersion ? 'summary-panel--without-margin' : 'summary-panel--with-margin'}>
                    {panel}
                </div>}
                {(showBackButtonInMobileVersion) &&
                    <BackButton mobile={true} onClick={onClickBack as (e: React.MouseEvent<HTMLButtonElement>) => void}/>}
                {iconProps ? <AppIcon {...iconProps} /> : null}
                <PageHeader {...props.title} align='center'
                        className={clsx(isMobileDevice && !showBackButtonInMobileVersion && !panel && !iconProps ? 'header-margin-top' : null )}
                />
                {children}
                {
                    showBackButtonInDesktopVersion && (
                        <BackButton mobile={false} onClick={onClickBack as (e: React.MouseEvent<HTMLButtonElement>) => void}/>)
                }
            </div>
        </main>
    )
}

export default PageScreen